module.exports = __webpack_public_path__ + "static/media/35.d3fceb2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/35.svg
// module id = 2826
// module chunks = 3